import validate from "/workspace/Optilink/web-portal-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/workspace/Optilink/web-portal-frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-authenticated": () => import("/workspace/Optilink/web-portal-frontend/middleware/isAuthenticated.ts"),
  "switch-layout": () => import("/workspace/Optilink/web-portal-frontend/middleware/switchLayout.ts")
}